import {
    FETCH_ALL_PERSONS,
    FETCH_MORE_PERSONS,
    UPDATE_PERSONS,
    TOGGLE_LEAD,
    GET_PERSON_BY_ID,
    UPDATE_PERSONS_FOR_MESSAGES,
    GET_LINKEDIN_DATA,
    CONNECT_ON_LINKEDIN
} from '../constants/ActionTypes';
import Utils from '../views/reactViews/Utils';
import _ from 'underscore';

function getInitialState() {
    return {
        facets: {},
        persons: []
    };
}

function setPersonInPersons(persons, selectedPerson) {

    let newPersons = persons.map((person) => (person.id == selectedPerson.id) ? selectedPerson : person);
    if (!_.contains(newPersons, selectedPerson)) {
        newPersons.push(selectedPerson);
    }
    return Utils.capitalizePersons(newPersons);
}


function PersonsReducer(state = getInitialState(), action = null) {
    switch (action.type) {

    case FETCH_ALL_PERSONS:
    {
        var facets = (action.response.facets && action.response.facets.attributes) || {};
        const persons = Utils.capitalizePersons(action.response.users);
        return Object.assign({}, state, {
            persons: persons,
            facets: facets
        });
    }

    case FETCH_MORE_PERSONS:
    {
        const newPersons = state.persons.slice().concat(action.response.users);
        const capitalizedPersons = Utils.capitalizePersons(newPersons);
        var newFacets = (action.response.facets && action.response.facets.attributes) || {};
        // const newFacets = state.facets.slice().concat(facets);
        return Object.assign({}, state, {
            persons: capitalizedPersons,
            facets: newFacets
        });
    }

    case UPDATE_PERSONS:
    {
        let newPersons = action.response.users || [];
        let persons = state.persons || [];
        newPersons.forEach(person => {
            persons = setPersonInPersons(persons, person);
        });
        return Object.assign({}, state, {
            persons: persons
        });
    }

    case TOGGLE_LEAD :
    {
        let person = _.findWhere(state.persons, {id: action.personId}) || {};
        const newPerson = Object.assign({}, person, {
            myLead: !person.myLead
        });
        return Object.assign({}, state, {
            persons: setPersonInPersons(state.persons, newPerson)
        });
    }

    case GET_PERSON_BY_ID :
    {
        let person = _.findWhere(state.persons, {id: action.personId}) || {};
        let selectedPerson = action.response.users && action.response.users[0];
        const newPerson = Object.assign({}, person, selectedPerson);
        return Object.assign({}, state, {
            persons: setPersonInPersons(state.persons, newPerson)
        });
    }

    case GET_LINKEDIN_DATA :
    {
        let person = _.findWhere(state.persons, {id: action.personId}) || {};
        let linkedinProfile = (person.linkedinProfile && JSON.parse(person.linkedinProfile)) || {};
        const newPerson = Object.assign({}, person, {
            linkedinInfo: Object.assign(action.linkedinData, linkedinProfile)
        });
        return Object.assign({}, state, {
            persons: setPersonInPersons(state.persons, newPerson)
        });
    }

    case CONNECT_ON_LINKEDIN:
    {
        const person = _.findWhere(state.persons, {id: action.personId}) || {};
        const newPerson = Object.assign({}, person, {
            linkedInInvitationSent: action.isSuccess
        });

        return Object.assign({}, state, {
            persons: setPersonInPersons(state.persons, newPerson)
        });
    }
    case UPDATE_PERSONS_FOR_MESSAGES:
    {
        return Object.assign({}, state, {
            persons: action.persons
        });
    }

    default:
        return state;
    }
}

export default PersonsReducer;
